module.exports = __webpack_public_path__ + "img/detail-2.4ec8d7df.jpg";